module.exports = __webpack_public_path__ + "static/media/Logo.89c93853.svg";